/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Modal,
  notification,
  Select,
  Tooltip,
  Typography,
  Upload,
  Row,
  Col,
  Table,
  Checkbox,
  Input,
  Spin,
} from 'antd';
import {
  PlusOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
  CloudUploadOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  RightCircleOutlined,
  SettingOutlined,
  FileDoneOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { get } from 'lodash';
import axios from 'axios';
import AddNewShipmentType from './AddNewShipmentType';
import ShipmentNo from './ShipmentNo';
import AddNewShipmentNumber from './AddNewShipmentNumber';
import { fetchShipmentTypeDetails, fetchShipments } from '../../redux/ShipmentDetails/actions';
import { fetchShipmentDashBoardDetails } from '../../redux/ShipmentDashboardDetails/actions';
import {
  getExportDataListFromDatabase,
  OnDeleteShipmentType,
  OnPreviewShipmentNumber,
  OnAddShipmentNumber,
  OnAddorUpdateShipmentType,
  OnBulkUpdateShipmentStatus,
  OnDeleteShipmentNumber,
} from '../../redux/ShipmentDetails/saga';
import { OnDeleteShipments } from '../../redux/ShipmentDashboardDetails/saga';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';
import ShipmentLogs from './ShipmentLogs';

const { Text, Title } = Typography;

// Add custom styles for checkbox
const customCheckboxStyle = `
.custom-checkbox .ant-checkbox-inner {
    width: 18px;
    height: 18px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    background-color: transparent;
}
.custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ef314c;
    border-color: #ef314c;
}
.custom-checkbox:hover .ant-checkbox-inner {
    border-color: #ef314c;
}
.custom-checkbox .ant-checkbox-inner::after {
    width: 6px;
    height: 10px;
    top: 45%;
    left: 22%;
}
`;

const ShippingManagement = (props) => {
  const {
    shipmentsTypes,
    shipmentTypesLoading,
    onFetchShipments,
    shipmentData,
    shipmentDataLoading,
    onGetShipmentTypes,
  } = props;

  const [checkOpen, setChecksOpen] = useState(false);
  const [openPage, setOpenPage] = useState('');
  const [showAddModel, setShowAddModel] = useState(false);

  const [openShipmentNoPage, setOpenShipmentNoPage] = useState(false);

  //Shipment Types
  const [equipTypeForm] = Form.useForm();
  const [equipTypeSearchForm] = Form.useForm();

  const [openModal, setOpenModel] = useState(false);
  const [equipTypeList, setEquipTypeListDrop] = useState([
    {
      id: 1,
      Shipment_Types: 'Air Freight',
    },
    {
      id: 2,
      Shipment_Types: 'Sea Freight',
    },
    {
      id: 3,
      Shipment_Types: 'Land Courier',
    },
    {
      id: 4,
      Shipment_Types: 'Hand Carry',
    },
  ]);
  const [clear, setClear] = useState(false);
  const [paginationClear, setPaginationClear] = useState(false);
  const [equipmentType, setEquipmentType] = useState('');
  const [editModelValue, setEditModelValue] = useState('');
  const [editRecord, setEditRecord] = useState('');
  const [isEdit, setIsEdit] = useState('');

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(100000);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isShipmentType, setIsShipmentType] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState('');
  const [shipmentDataList, setShipmentDataList] = useState([]);
  const [searchType, setSearchType] = useState(null);
  const [searchFilterType, setSearchFilterType] = useState('');
  const [rowData, setRowData] = useState([]);
  const [archivedData, setArchivedData] = useState([]);
  const [nonArchivedData, setNonArchivedData] = useState([]);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isArchiveLoading, setIsArchiveLoading] = useState(false);
  const [error, setError] = useState(null);

  // Add state for selected rows
  const [selectedRows, setSelectedRows] = useState([]);

  // Add state for shipment types in dropdown
  const [shipmentTypesForDropdown, setShipmentTypesForDropdown] = useState([]);
  const [isLoadingShipmentTypes, setIsLoadingShipmentTypes] = useState(false);
  const [previewShipmentNumber, setPreviewShipmentNumber] = useState('');
  const [selectedShipmentType, setSelectedShipmentType] = useState(null);
  const [addLoading, setAddLoading] = useState(false);

  // Add state for shipment type modal
  const [showShipmentTypeFormModal, setShowShipmentTypeFormModal] = useState(false);
  const [shipmentTypeForm] = Form.useForm();
  const [isEditShipmentType, setIsEditShipmentType] = useState(false);
  const [editingShipmentType, setEditingShipmentType] = useState(null);

  // Update initial state to false (show only active)
  const [showArchived, setShowArchived] = useState(false);

  // Add state for shipment type name
  const [shipmentTypeName, setShipmentTypeName] = useState('');

  // Add state for equipment type id
  const [equipmentTypeId, setEquipmentTypeId] = useState(null);

  // Add state for shipment logs
  const [isTableModelVisible, setIsTableModelVisible] = useState(false);
  const [showFormModel, setShowFormModel] = useState(false);

  // Add state for document modal
  const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
  const [selectedDocumentData, setSelectedDocumentData] = useState(null);

  // Add state for delete modal
  const [selectedDataSno, setSelectedDataSno] = useState(null);

  const [form] = Form.useForm();

  const [isPageLoading, setIsPageLoading] = useState(false);

  // Document modal columns
  const documentColumns = [
    {
      title: 'File Name',
      dataIndex: 'fileName',
      key: 'fileName',
      align: 'left',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'left', height: '100%' }}>{text}</div>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'edit_delete',
      key: 'edit_delete',
      align: 'center',
      render: (text, record) => {
        return (
          <div>
            <Tooltip title="Download">
              <Button
                href={`${process.env.REACT_APP_AWS_IMAGE_URL}/${record.fileKey}`}
                className="p-0 border-0"
                size="small"
                target="_blank"
                style={{ marginLeft: '10px' }}
              >
                <DownloadOutlined className="pdfIconRed" />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const typesListColumns = [
    {
      title: 'Shipment Types',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      // sorter: (a, b) => {return (a-b)},
      ellipsis: true,
    },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '150px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip title="View Shipments">
              <span
                className="icon-18 mr-2 cursor-pointer edit-hover"
                style={{ marginRight: '20px' }}
              >
                <EyeOutlined
                  style={{ fontSize: '18px' }}
                  onClick={() => {
                    handleEyeClick(record);
                  }}
                />
              </span>
            </Tooltip>
            <Tooltip title="Delete" placement="top">
              {' '}
              <DeleteOutlined
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c' }}
                onClick={() => showDeleteModal(record, false)}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },

    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip title="Shipments" placement="top">
              <RightCircleOutlined
                className="icon-22"
                onClick={async () => {
                  setSelectedData(record);
                  setChecksOpen(true);
                  setOpenShipmentNoPage(true);

                  // setOpenPage('equipment');
                  // equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setShipmentTypeName(record.name);
                  setEquipmentTypeId(record.id);
                  // console.log(record)
                  // await onGetEquipSno({ pihEquipmentType: record.pihEquipmentType });
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  const [showShipmentTypesModal, setShowShipmentTypesModal] = useState(false);
  const [shipmentTypesData, setShipmentTypesData] = useState([]);
  const [isShipmentTypesLoading, setIsShipmentTypesLoading] = useState(false);

  const handleOpenShipmentTypesModal = async () => {
    setShowShipmentTypesModal(true);
    setIsShipmentTypesLoading(true);
    try {
      const response = await getExportDataListFromDatabase();
      if (response && response.rows) {
        // Add S.No to each row
        const dataWithSno = response.rows.map((item, index) => ({
          ...item,
          sno: index + 1,
        }));
        setShipmentTypesData(dataWithSno);
      } else if (Array.isArray(response)) {
        // Add S.No to each row
        const dataWithSno = response.map((item, index) => ({
          ...item,
          sno: index + 1,
        }));
        setShipmentTypesData(dataWithSno);
      } else {
        setShipmentTypesData([]);
      }
    } catch (error) {
      console.error('Error fetching shipment types:', error);
      setShipmentTypesData([]);
    } finally {
      setIsShipmentTypesLoading(false);
    }
  };

  const [showAddShipmentNumberModal, setShowAddShipmentNumberModal] = useState(false);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const handleEyeClick = async (record) => {
    setSelectedData(record);
    setIsTableModelVisible(true);
    setShowFormModel(true);
  };

  const handleDocumentClick = (record) => {
    setSelectedDocumentData(record);
    setIsDocumentModalVisible(true);
  };

  // Update handleSelectionChanged function with more detailed logging
  const handleSelectionChanged = (params) => {
    // Handle both array and object params
    const selectedRows = Array.isArray(params) ? params : params?.api?.getSelectedRows() || [];

    // Log each selected row's details
    selectedRows.forEach((row, index) => {});

    setSelectedRows(selectedRows);
  };

  // Add useEffect to monitor selectedRows changes

  // Update the button style logic
  const getButtonStyle = (selectedRows) => {
    const isEnabled = selectedRows?.length > 0;
    return {
      opacity: isEnabled ? 1 : 0.5,
      cursor: isEnabled ? 'pointer' : 'not-allowed',
      pointerEvents: isEnabled ? 'auto' : 'none',
    };
  };

  // Update onGridReady handler with logging
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  // Update the column definitions to include checkbox selection
  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'sno',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        valueGetter: (params) => params.data.sno,
        suppressMovable: true,
        lockPosition: true,
        checkboxSelection: true,
        // headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Shipment Number',
        field: 'shipmentNumber',
        sortable: true,
        cellStyle: (params) => {
          if (params.data.status === 'ARCHIVED') {
            return {
              textAlign: 'left',
              color: '#999',
              fontStyle: 'italic',
            };
          }
          return { textAlign: 'left' };
        },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        cellStyle: (params) => {
          if (params.value === 'ARCHIVED') {
            return {
              textAlign: 'left',
              color: '#999',
              fontStyle: 'italic',
            };
          }
          return { textAlign: 'left' };
        },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Shipment Type',
        field: 'shipmentType',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => params.data?.shipmentType?.name || '',
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Invoice Number',
        field: 'invoiceNumber',
        sortable: true,
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        headerClass: 'ag-center-header',
        valueGetter: (params) => {
          // Get invoice number from submissions if available
          const submissions = params.data?.submissions || [];
          const submission = submissions.find((sub) => sub.invoice_number);
          return submission?.invoice_number || params.data?.invoiceNumber || '';
        },
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Actions',
        field: 'editDelete',
        width: 150,
        pinned: 'right',
        headerClass: 'ag-center-header',
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div className="tableIcons">
              <Tooltip title="View Shipment" placement="left">
                <EyeOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => handleEyeClick(record)}
                />
              </Tooltip>
              <Tooltip title="Documents" placement="top">
                <FileDoneOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => handleDocumentClick(record)}
                />
              </Tooltip>
              <Tooltip title="Delete" placement="top">
                <DeleteOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => {
                    setSelectedData(record);
                    setIsDeleteModalVisible(true);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        cellStyle: { textAlign: 'center' },
        filter: false,
        suppressMovable: true,
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    (async () => {
      const list = await getExportDataListFromDatabase();

      if (list && list.rows.length > 0) setShipmentDataList(list.rows);
    })();
  }, []);

  useEffect(() => {
    if (shipmentsTypes && shipmentsTypes.length > 0) {
      setRowData(shipmentsTypes);
    }
  }, [shipmentsTypes]);

  useEffect(() => {
    OnfetchData();
  }, [searchCriteria]);

  // const fetchShipments = async () => {
  //     try {
  //         setIsLoading(true);
  //         setError(null);
  //         const response = await axios.get('http://localhost:9002/asset-management/');
  //         if (response.data) {
  //             setRowData(response.data);
  //         }
  //     } catch (err) {
  //         setError('Failed to fetch shipments');
  //         notification.error({
  //             message: 'Error',
  //             description: 'Failed to fetch shipments. Please try again later.'
  //         });
  //     } finally {
  //         setIsLoading(false);
  //     }
  // };

  useEffect(() => {
    onFetchShipments({ status: showArchived ? 'archived' : 'active' });
  }, [showArchived]);

  // Add useEffect for initial data load
  useEffect(() => {
    // Initial load with active status
    OnfetchData({
      status: 'active',
    });
  }, []); // Empty dependency array means this runs once on mount

  // Update OnfetchData to handle initial load
  const OnfetchData = async (params = {}) => {
    try {
      setIsLoading(true);
      setIsPageLoading(true);
      const queryParams = {
        ...params,
        status: params.status || (showArchived ? 'archived' : 'active'),
        pageSize: currentPagesize,
        pageNumber: searchCriteria !== '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
        projectId: props.selectedProject?.id,
      };
      await onFetchShipments(queryParams);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch shipments',
      });
    } finally {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

  const onShowEditModel = (record) => {
    setEditRecord({
      pihShipmentId: record.id,
      shipmentTypeId: record.shipmentTypeId,
      projectId: record.projectId,
      shipmentId: record.shipmentId,
      status: record.status,
    });
    setIsEdit(true);
    setShowAddModel(true);
  };

  const showDeleteModal = (record, isType = false) => {
    setSelectedData(record);
    setIsShipmentType(isType);
    setIsDeleteModalVisible(true);
  };

  const handleOk = async () => {
    setDeleteLoading(true);
    try {
      if (isShipmentType) {
        await OnDeleteShipmentType(selectedData);
        await handleOpenShipmentTypesModal();
      } else {
        await OnDeleteShipmentNumber(selectedData);
        await OnfetchData({
          status: showArchived ? 'archived' : 'active',
          projectId: props.selectedProject?.id,
        });
        await onFetchShipments({
          status: showArchived ? 'archived' : 'active',
          projectId: props.selectedProject?.id,
        });
      }

      notification.success({
        message: 'Success',
        description: `Successfully deleted ${isShipmentType ? 'shipment type' : 'shipment'}`,
      });

      setIsDeleteModalVisible(false);
      setSelectedData(null);
      setIsShipmentType(false);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: `Failed to delete ${isShipmentType ? 'shipment type' : 'shipment'}`,
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData(null);
    setIsShipmentType(false);
  };

  const handleSearchInputChange = (value) => {
    //  if (value != '')
    setSearchFilterType(value);
    if (searchFilterType.length == 1 || value != '') setSearchCriteria(value);
    // else
    //     setSearchCriteria('');
  };

  const handleComboboxChange = async (value) => {
    setSearchType(value);
    if (value) setSearchCriteria(value);
    else setSearchCriteria('');
  };
  const handleSearchBlur = () => {
    const isValid = EquipmentDataList.some(
      (item) => item.pihEquipmentType?.toLowerCase() === searchCriteria?.toLowerCase()
    );
    if (!isValid) {
      console.log('handleSearchBlur', isValid);
      setSearchCriteria('');
      setSearchType(undefined);
    }
  };
  const tagRender = (props) => {
    return null;
  };

  /** clearing selected data from equipment type dropdown */
  const OnclearEquipType = () => {
    setClear(false);
    setSearchCriteria('');
    setSearchFilterType('');
    setSearchType(null);
    equipTypeSearchForm.resetFields();
    // setEquipTypeList(adminEquipTypes)
    setPaginationClear(false);
    // onGetPihEquipmentTypes({
    //     pageSize: 10,
    //     pageNumber: 1
    // });
    // setEquipTypeListDrop(adminEquipTypes);
  };

  useEffect(() => {
    if (shipmentData && shipmentData.length > 0) {
      const archived = shipmentData.filter((item) => item.status === 'ARCHIVED');
      const nonArchived = shipmentData.filter((item) => item.status !== 'ARCHIVED');

      setArchivedData(archived);
      setNonArchivedData(nonArchived);

      setRowData(showArchived ? archived : nonArchived);

      if (gridApi) {
        gridApi.setRowData(showArchived ? archived : nonArchived);
        gridApi.refreshCells({ force: true });
        gridApi.redrawRows();
      }
    }
  }, [shipmentData]);

  useEffect(() => {
    if (shipmentData && shipmentData.length > 0) {
      const filteredData = showArchived
        ? shipmentData.filter((item) => item.status === 'ARCHIVED')
        : shipmentData.filter((item) => item.status !== 'ARCHIVED');

      setRowData([...filteredData]);

      if (gridApi) {
        gridApi.setRowData([...filteredData]);
        gridApi.refreshCells({ force: true });
        gridApi.redrawRows();
      }
    }
  }, [shipmentData, showArchived]);

  // Update handleShowArchivedChange to use loading state
  const handleShowArchivedChange = async (e) => {
    const isChecked = e.target.checked;
    setShowArchived(isChecked);
    setIsArchiveLoading(true);
    setIsLoading(true);
    setIsPageLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      await OnfetchData({
        status: isChecked ? 'archived' : 'active',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch shipments',
      });
    } finally {
      setTimeout(() => {
        setIsArchiveLoading(false);
        setIsLoading(false);
        setIsPageLoading(false);
      }, 500);
    }
  };

  // Update handleArchiveSelected to use loading state
  const handleArchiveSelected = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      notification.warning({
        message: 'Warning',
        description: 'Please select shipments to archive',
      });
      return;
    }

    try {
      setIsLoading(true);
      setDeleteLoading(true);
      setIsPageLoading(true);

      const payload = {
        shipmentIds: selectedRows.map((row) => row.id),
        status: 'archived',
      };

      const result = await OnBulkUpdateShipmentStatus(payload);
      if (result) {
        notification.success({
          message: 'Success',
          description: `Successfully archived ${selectedRows.length} shipment(s)`,
        });

        setSelectedRows([]);
        if (gridApi) {
          gridApi.deselectAll();
        }

        await OnfetchData({
          status: 'active',
          projectId: props.selectedProject?.id,
        });

        await onFetchShipments({ status: 'active' });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to archive shipments',
      });
    } finally {
      setIsLoading(false);
      setDeleteLoading(false);
      setIsPageLoading(false);
    }
  };

  // Update useEffect to handle initial data load with status
  useEffect(() => {
    OnfetchData({
      status: showArchived ? 'archived' : 'active',
    });
  }, [showArchived]);

  // Add useEffect to call preview API when modal opens
  useEffect(() => {
    if (showAddShipmentNumberModal) {
      const fetchPreview = async () => {
        try {
          setAddLoading(true);
          const previewData = await OnPreviewShipmentNumber(selectedShipmentType);
          if (previewData && previewData.previewShipmentNumber) {
            setPreviewShipmentNumber(previewData.previewShipmentNumber);
          } else {
            notification.error({
              message: 'Failed to generate shipment number preview',
            });
          }
        } catch (error) {
          notification.error({
            message: 'Error generating shipment number',
            description: error?.message || 'Unknown error',
          });
        } finally {
          setAddLoading(false);
        }
      };
      fetchPreview();
    }
  }, [showAddShipmentNumberModal]);

  const handleAddButtonClick = async () => {
    setShowAddShipmentNumberModal(true);
    // Fetch shipment types when modal opens
    await fetchShipmentTypesForDropdown();
  };

  // Add function to fetch shipment types for dropdown
  const fetchShipmentTypesForDropdown = async () => {
    setIsLoadingShipmentTypes(true);
    try {
      const response = await getExportDataListFromDatabase();
      if (response && response.rows) {
        setShipmentTypesForDropdown(response.rows);
        // Set the first shipment type as default and get preview
        if (response.rows.length > 0) {
          setSelectedShipmentType(response.rows[0].id);
        }
      } else if (Array.isArray(response)) {
        setShipmentTypesForDropdown(response);
        if (response.length > 0) {
          setSelectedShipmentType(response[0].id);
        }
      } else {
        setShipmentTypesForDropdown([]);
      }
    } catch (error) {
      console.error('Error fetching shipment types:', error);
      setShipmentTypesForDropdown([]);
    } finally {
      setIsLoadingShipmentTypes(false);
    }
  };

  const handleConfirmAdd = async () => {
    try {
      // Validate form first
      await form.validateFields();

      if (!selectedShipmentType || !previewShipmentNumber) {
        notification.error({
          message: 'Error',
          description: 'Please select a shipment type first',
        });
        return;
      }

      setAddLoading(true);
      const payload = {
        shipment: {
          shipmentTypeId: selectedShipmentType,
        },
      };

      const response = await OnAddShipmentNumber(payload);
      if (response?.shipment?.shipmentNumber) {
        notification.success({
          message: `Shipment number ${response.shipment.shipmentNumber} added successfully`,
        });

        // Refresh data with current status
        await onFetchShipments({
          status: showArchived ? 'archived' : 'active',
          projectId: props.selectedProject?.id,
        });

        // Reset form and states
        setShowAddShipmentNumberModal(false);
        setSelectedShipmentType(null);
        setPreviewShipmentNumber('');
        form.resetFields();
      }
    } catch (error) {
      notification.error({
        message: 'Failed to add shipment number',
      });
    } finally {
      setAddLoading(false);
    }
  };

  const handleCancelAdd = () => {
    setShowAddShipmentNumberModal(false);
    setPreviewShipmentNumber('');
    setSelectedShipmentType(null);
    form.resetFields();
  };

  // Add function to handle shipment type form submission
  const handleShipmentTypeSubmit = async (values) => {
    try {
      setAddLoading(true);
      const payload = {
        id: isEditShipmentType ? editingShipmentType.id : undefined,
        data: {
          name: values?.name || '',
        },
      };

      await OnAddorUpdateShipmentType(payload, isEditShipmentType);
      notification.success({
        message: `Shipment type ${isEditShipmentType ? 'updated' : 'created'} successfully`,
      });
      await handleOpenShipmentTypesModal(); // Refresh the list
      setShowShipmentTypeFormModal(false);
      shipmentTypeForm.resetFields();
      setIsEditShipmentType(false); // Reset edit mode
      setEditingShipmentType(null); // Clear editing data
    } catch (error) {
      notification.error({
        message: `Failed to ${isEditShipmentType ? 'update' : 'create'} shipment type`,
        description: error?.message || 'An error occurred',
      });
    } finally {
      setAddLoading(false);
    }
  };

  // Add function to handle edit shipment type
  const handleEditShipmentType = (record) => {
    setIsEditShipmentType(true);
    setEditingShipmentType(record);
    shipmentTypeForm.setFieldsValue({
      name: record.name,
    });
    setShowShipmentTypeFormModal(true);
  };

  // Add function to handle new shipment type
  const handleNewShipmentType = () => {
    setIsEditShipmentType(false);
    setEditingShipmentType(null);
    shipmentTypeForm.resetFields();
    setShowShipmentTypeFormModal(true);
  };

  // Add function to handle cancel shipment type form
  const handleCancelShipmentTypeForm = () => {
    setShowShipmentTypeFormModal(false);
    setIsEditShipmentType(false);
    setEditingShipmentType(null);
    shipmentTypeForm.resetFields();
  };

  // Add function to handle bulk status update
  const handleBulkStatusUpdate = async (status) => {
    if (selectedRows.length === 0) {
      notification.warning({
        message: 'Please select shipments to update',
      });
      return;
    }

    try {
      const payload = {
        shipmentIds: selectedRows.map((row) => row.id),
        status: status,
      };

      const result = await OnBulkUpdateShipmentStatus(payload);
      if (result) {
        await OnfetchData(); // Refresh the data
        setSelectedRows([]); // Clear selection
      }
    } catch (error) {
      console.error('Error updating shipment statuses:', error);
    }
  };

  // Add delete handlers
  const handleDeleteOk = async () => {
    setDeleteLoading(true);
    try {
      await OnDeleteShipmentNumber(selectedDataSno);
      await OnfetchData({
        status: showArchived ? 'archived' : 'active',
        projectId: props.selectedProject?.id,
      });
      notification.success({
        message: 'Success',
        description: 'Shipment deleted successfully',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete shipment',
      });
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalVisible(false);
      setSelectedDataSno(null);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedDataSno(null);
  };

  return (
    <div className="admin">
      <style>{customCheckboxStyle}</style>
      {isPageLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <Spin size="large" tip="Loading..." />
        </div>
      )}
      {!openShipmentNoPage && (
        <div>
          <div className="d-flex mt-0.5 mb-2 justify-content-between tab-content-title">
            <div className="d-flex align-items-center">
              <Title className="mb-0" level={4}>
                List of Shipments
              </Title>
            </div>

            <div className="d-flex align-items-center">
              <Checkbox
                checked={showArchived}
                onChange={handleShowArchivedChange}
                className="custom-checkbox"
                style={{ marginRight: 20 }}
                disabled={isArchiveLoading}
              >
                <span style={{ opacity: isArchiveLoading ? 0.5 : 1 }}>
                  {isArchiveLoading ? 'Loading...' : 'Show Archived Shipments'}
                </span>
              </Checkbox>
              <div>
                <div className="text-right new-calibration new-calibration new-project-team">
                  <Text onClick={handleOpenShipmentTypesModal} className="ps-3 add-new-team">
                    <span className="icon-22">
                      <svg>
                        <use xlinkHref="#add" />
                      </svg>
                    </span>
                    View/Add Shipment Type
                  </Text>

                  <Text
                    onClick={handleArchiveSelected}
                    className="ps-3 add-new-team"
                    style={getButtonStyle(selectedRows)}
                  >
                    <span className="icon-22">
                      <svg>
                        <use xlinkHref="#add" />
                      </svg>
                    </span>
                    {isLoading
                      ? 'Archiving...'
                      : `Archive Selected ${
                          selectedRows?.length > 0 ? `(${selectedRows.length})` : ''
                        }`}
                  </Text>

                  <Text
                    onClick={() => setShowAddShipmentNumberModal(true)}
                    className="ps-3 add-new-team"
                  >
                    <span className="icon-22">
                      <svg>
                        <use xlinkHref="#add" />
                      </svg>
                    </span>
                    Add Shipment Number
                  </Text>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-line" />
          <div>
            <Row gutter={24}>
              <Col span={24} style={{ padding: '0px 12px 0' }}>
                <CommonAGGridTable
                  rowData={rowData}
                  columnDefs={columnDefs}
                  activeKeyLine="List of Shipments"
                  isRawListLoading={
                    shipmentDataLoading || rowData.length === 0 || isLoading || isArchiveLoading
                  }
                  loadingMessage={
                    isArchiveLoading
                      ? 'Loading archived shipments...'
                      : isLoading
                      ? 'Refreshing data...'
                      : 'Loading Shipments...'
                  }
                  onSelectionChanged={handleSelectionChanged}
                  onGridReady={onGridReady}
                  rowSelection="multiple"
                  suppressRowClickSelection={true}
                  enableCellTextSelection={true}
                  ensureDomOrder={true}
                  suppressCellFocus={true}
                  suppressRowVirtualisation={true}
                  multiSelect={true}
                />
              </Col>
            </Row>
          </div>
        </div>
      )}

      {openShipmentNoPage && (
        <div>
          <div className="back_equip">
            <Tooltip title={' Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  setChecksOpen(false);
                  setOpenPage('');
                  setOpenShipmentNoPage(false);
                  setShipmentTypeName('');
                  setSelectedData(null); // Clear selected data when closing
                }}
              />
            </Tooltip>
            <Text style={{ fontSize: '16px', paddingLeft: '10px' }}>{shipmentTypeName}</Text>
          </div>
          <ShipmentNo
            selectedData={selectedData}
            onDeleteSuccess={() => {
              // Refresh data after successful deletion
              OnfetchData({
                status: showArchived ? 'archived' : 'active',
                projectId: props.selectedProject?.id,
              });
            }}
          />
        </div>
      )}

      <AddNewShipmentType
        showAddModel={showAddModel}
        setShowAddModel={setShowAddModel}
        setIsEdit={setIsEdit}
        editRecord={editRecord}
        isEdit={isEdit}
        OnfetchData={OnfetchData}
      ></AddNewShipmentType>

      {/* Delete Modal for Shipment Number */}
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Delete Shipment Number"
        centered
        visible={isDeleteModalVisible && !isShipmentType}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleOk} loading={deleteLoading}>
            Delete
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting shipment number will delete all the corresponding Stations and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{selectedData && selectedData.shipmentNumber}</b>{' '}
            shipment number?
          </Text>
        </div>
      </Modal>

      {/* Delete Modal for Shipment Type */}
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Delete Shipment Type"
        centered
        visible={isDeleteModalVisible && isShipmentType}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleOk} loading={deleteLoading}>
            Delete
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting shipment type will delete all the corresponding shipment numbers and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{selectedData && selectedData.name}</b> shipment type?
          </Text>
        </div>
      </Modal>

      {/* Shipment Type Form Modal */}
      <Modal
        width="45vw"
        className="pipeline-modal"
        title={isEditShipmentType ? 'Update Shipment Type' : 'Create New Shipment Type'}
        centered
        visible={showShipmentTypeFormModal}
        footer={[
          <Button key="cancel" onClick={handleCancelShipmentTypeForm}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => shipmentTypeForm.submit()}
            loading={addLoading}
          >
            {isEditShipmentType ? 'Update' : 'Create'}
          </Button>,
        ]}
      >
        <div style={{ padding: '20px 0' }}>
          <Form form={shipmentTypeForm} layout="vertical" onFinish={handleShipmentTypeSubmit}>
            <Form.Item
              label="Shipment Type Name"
              name="name"
              rules={[
                { required: true, message: 'Please enter shipment type name' },
                { max: 50, message: 'Name cannot exceed 50 characters' },
              ]}
            >
              <Input placeholder="Enter shipment type name" />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* Shipment Types Modal */}
      <Modal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <span>Shipment Types</span>
            <div className="text-right new-calibration new-calibration new-project-team mb-3">
              <Button
                type="text"
                onClick={() => handleNewShipmentType()}
                className="ps-3 add-new-team"
                style={{
                  padding: 0,
                  height: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  color: 'inherit',
                }}
              >
                <span className="icon-22">
                  <svg>
                    <use xlinkHref="#add" />
                  </svg>
                </span>
                <span style={{ marginLeft: 8 }}>Add New Shipment Type</span>
              </Button>
            </div>
          </div>
        }
        visible={showShipmentTypesModal}
        onCancel={() => setShowShipmentTypesModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowShipmentTypesModal(false)}>
            Cancel
          </Button>,
        ]}
        width="60%"
        centered
        bodyStyle={{
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          height: '600px',
        }}
      >
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: 1, overflow: 'auto' }}>
            <CommonAGGridTable
              rowData={shipmentTypesData}
              columnDefs={[
                {
                  headerName: 'S.No',
                  field: 'sno',
                  maxWidth: 200,
                  headerClass: 'ag-center-header',
                  cellStyle: { textAlign: 'center' },
                  valueGetter: (params) => params.data.sno,
                  suppressMovable: true,
                  lockPosition: true,
                  filter: 'agMultiColumnFilter',
                  filterParams: {
                    filters: [
                      {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                          filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                          buttons: ['reset'],
                        },
                      },
                      {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                          buttons: ['reset'],
                        },
                      },
                    ],
                  },
                },
                {
                  headerName: 'Shipment Types',
                  field: 'name',
                  sortable: true,
                  cellStyle: { textAlign: 'left' },
                  suppressMovable: true,
                  headerClass: 'ag-center-header',
                  filter: 'agMultiColumnFilter',
                  filterParams: {
                    filters: [
                      {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                          filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                          buttons: ['reset'],
                        },
                      },
                      {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                          buttons: ['reset'],
                        },
                      },
                    ],
                  },
                },
                {
                  headerName: 'Actions',
                  field: 'editDelete',
                  width: 150,
                  pinned: 'right',
                  headerClass: 'ag-center-header',
                  cellRenderer: (params) => {
                    const record = params.data;
                    return (
                      <div className="tableIcons">
                        <Tooltip title="Update" placement="left">
                          <EditOutlined
                            className="icon-18"
                            style={{ margin: '0 10px', color: '#ef314c' }}
                            onClick={() => handleEditShipmentType(record)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete" placement="top">
                          <DeleteOutlined
                            className="icon-18"
                            style={{ margin: '0 10px', color: '#ef314c' }}
                            onClick={() => showDeleteModal(record, true)}
                          />
                        </Tooltip>
                      </div>
                    );
                  },
                  cellStyle: { textAlign: 'center' },
                  filter: false,
                  suppressMovable: true,
                },
              ]}
              activeKeyLine="List of Shipment Types"
              isRawListLoading={isShipmentTypesLoading}
              loadingMessage="Loading Shipment Types..."
              height="calc(100vh - 400px)"
            />
          </div>
        </div>
      </Modal>

      {/* Add Shipment Number Modal */}
      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Confirm New Shipment Number"
        centered
        visible={showAddShipmentNumberModal}
        footer={[
          <Button key="cancel" onClick={handleCancelAdd}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={handleConfirmAdd}
            loading={addLoading}
            disabled={!selectedShipmentType || !previewShipmentNumber}
          >
            Confirm
          </Button>,
        ]}
      >
        <div style={{ padding: '20px 0' }}>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(changedValues) => {
              if (changedValues.shipmentType) {
                setSelectedShipmentType(changedValues.shipmentType);
              } else {
                setSelectedShipmentType(null);
                setPreviewShipmentNumber('');
              }
            }}
          >
            <Form.Item
              label="Shipment Type"
              name="shipmentType"
              rules={[{ required: true, message: 'Please select a shipment type' }]}
              validateTrigger={['onChange', 'onBlur']}
            >
              <Select
                placeholder="Select Shipment Type"
                loading={isLoadingShipmentTypes}
                onDropdownVisibleChange={(open) => {
                  if (open) {
                    fetchShipmentTypesForDropdown();
                  }
                }}
                onChange={(value) => {
                  if (value) {
                    form.setFieldsValue({ shipmentType: value });
                    setSelectedShipmentType(value);
                  } else {
                    form.setFieldsValue({ shipmentType: undefined });
                    setSelectedShipmentType(null);
                    setPreviewShipmentNumber('');
                  }
                }}
                allowClear={false}
              >
                {shipmentTypesForDropdown.map((type) => (
                  <Select.Option key={type.id} value={type.id}>
                    {type.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {selectedShipmentType && previewShipmentNumber && (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Text style={{ fontSize: '16px', display: 'block', marginBottom: '10px' }}>
                  Do you want to add the following shipment number?
                </Text>
                <Text
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#EF314C',
                    display: 'block',
                  }}
                >
                  {previewShipmentNumber}
                </Text>
              </div>
            )}
          </Form>
        </div>
      </Modal>

      {/* Add ShipmentLogs component */}
      {showFormModel && (
        <ShipmentLogs
          showFormModel={showFormModel}
          setShowFormModel={setShowFormModel}
          selectedData={selectedData}
        />
      )}

      {/* Document Modal */}
      <Modal
        width="50vw"
        className="pipeline-modal"
        title="Shipment Documents"
        centered
        visible={isDocumentModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsDocumentModalVisible(false);
              setSelectedDocumentData(null);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <div>
          <Table
            columns={documentColumns}
            dataSource={selectedDocumentData?.document || []}
            pagination={false}
            width={'100%'}
            className="h-100 pipeline-table equipPaginationTable log-table logDetails_table"
            style={{ marginBottom: '20px' }}
            locale={{
              emptyText: 'No documents uploaded yet',
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ ShipmentReducer, ShipmentDashBoardReducer }) => {
  const shipmentsTypes = get(ShipmentReducer, 'shipmentData', []);
  const shipmentTypesLoading = get(ShipmentReducer, 'isShipmentTypeLoading', false);
  const shipmentTypesCount = get(ShipmentReducer, 'isShipmentTypeLoading', false);
  const shipmentData = get(ShipmentDashBoardReducer, 'shipmentListData', []);
  const shipmentDataLoading = get(ShipmentDashBoardReducer, 'isShipmentsLoading', false);
  return {
    shipmentsTypes,
    shipmentTypesLoading,
    shipmentTypesCount,
    shipmentData,
    shipmentDataLoading,
  };
};

const mapDispatchToProps = {
  onGetShipmentTypes: fetchShipmentTypeDetails,
  onFetchShipments: fetchShipments,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingManagement);
